export default __webpack_public_path__ + "static/media/list.d5b12b8f.jpg";